import React from 'react';

/**
 * EnforcedText - Ensures consistent text rendering
 * Prevents text manipulation while maintaining accessibility
 */

const EnforcedText = ({ children, className = '' }) => {
  return (
    <span 
      className={className}
      style={{ unicodeBidi: 'plaintext' }}
    >
      {children}
    </span>
  );
};

export default EnforcedText;
